import clsx from 'clsx';
import React from 'react';
import { Button } from '../button';
import { Icon } from '../icon';
import Icons from '@/const/icons';

type Types = 'info' | 'error';

interface Props {
	type?: Types;
	text: React.ReactNode;
	onCancel: () => void;
	onContinue: () => void;
	icon?: React.ReactElement;
	className?: string;
	classNameIcon?: string;
}

export const AlertActions: React.FC<Props> = ({
	type = 'info',
	icon,
	text,
	onCancel,
	onContinue,
	className,
	classNameIcon,
}) => {
	const dirIcons = {
		info: (
			<Icon
				src={Icons.rotateLeft}
				width={20}
				height={20}
				className={clsx(
					'text-main-blue-dark h-5 w-5 flex-shrink-0',
					classNameIcon
				)}
			/>
		),
		error: (
			<Icon
				src={Icons.redDanger}
				className={clsx('text-main-red !size-6 flex-shrink-0', classNameIcon)}
			/>
		),
		warning: (
			<Icon
				src={Icons.yellowDanger}
				className={clsx('!size-6 flex-shrink-0', classNameIcon)}
			/>
		),
	};
	return (
		<div
			className={clsx(
				'flex items-center justify-between rounded-[20px] py-6 px-3 gap-4',
				{
					'bg-[#3957F41A] border border-main-blue-dark': type === 'info',
					'bg-[#FF00430D] border border-[#FF00434D]': type === 'error',
				},
				className
			)}
		>
			<div className="flex items-center gap-4">
				{icon || dirIcons[type]}
				{text}
			</div>
			<div className="flex items-center gap-2">
				<Button
					size="fit"
					type="button"
					decoration="line-primary"
					className="!h-[30px]"
					onClick={onCancel}
				>
					Cancel
				</Button>
				<Button
					size="fit"
					type="button"
					className={clsx('!h-[30px]', {
						'!bg-transparent': type === 'error',
					})}
					decoration={type === 'info' ? 'primary' : 'danger-outline'}
					onClick={onContinue}
				>
					Confirm
				</Button>
			</div>
		</div>
	);
};
